import React from "react";
import { IonApp } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import MainRouter from "components/MainRouter/MainRouter";
import AuthProvider from "providers/AuthProvider/AuthProvider";
import GoodChatProvider from "providers/GoodChatProvider/GoodChatProvider";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "theme/variables.css";

const App: React.FC = () => {
  return (
    <IonApp>
      <AuthProvider>
        <GoodChatProvider>
          <IonReactRouter>
            <MainRouter />
          </IonReactRouter>
        </GoodChatProvider>
      </AuthProvider>
    </IonApp>
  );
};

export default App;
